import { useEffect, useState } from 'react';
import type { SkillInfo, SkillListing } from '../types/agent';

export interface SkillsApi {
  getSkills(): Promise<SkillListing>;
}

/** The Skills the composer's `/` menu lists, read once: the server reads them at startup, so they do not change
 *  while the pane is open. Empty until loaded, on an older server or offline, and when `enabled` is false (no
 *  request then): the menu never opens. */
export function useSkills(api: SkillsApi, enabled = true): SkillInfo[] {
  const [skills, setSkills] = useState<SkillInfo[]>([]);
  useEffect(() => {
    if (!enabled) {
      setSkills([]);
      return;
    }
    let live = true;
    api.getSkills().then(
      (listing) => {
        if (live) setSkills(listing.skills);
      },
      () => undefined,
    );
    return () => {
      live = false;
    };
  }, [api, enabled]);
  return skills;
}
